import { baseApi } from "../../../app/api";
import {
  FranchiseFormPayload,
  FranchiseFormResponse,
} from "../types/franchiseApiTypes";

const CUSTOM_REST_API_BASE =
  window.commonVariables?.customRestApiBase || "/wp-json/ecommerce-app/v1";

export const franchiseApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    submitFranchiseForm: builder.mutation<
      FranchiseFormResponse,
      FranchiseFormPayload
    >({
      query: (payload) => {
        const apiBody = {
          ...payload,
          form_load_timestamp: payload.formLoadTimestamp,
        };
        delete (apiBody as any).formLoadTimestamp;

        return {
          url: `${CUSTOM_REST_API_BASE}/forms/franchise`,
          method: "POST",
          body: apiBody,
        };
      },
    }),
  }),
});

export const { useSubmitFranchiseFormMutation } = franchiseApi;
